var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRbLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 900 900",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 471.584,
    x2: 120.542,
    y1: 268.735,
    y2: -115.365
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd543a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc801d"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 458.207,
    x2: 444.987,
    y1: 372.848,
    y2: 102.597
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd543a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe2857"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 170.19,
    x2: 235.765,
    y1: 522.417,
    y2: 86.845
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8352a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe2857"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 1319.98,
    x2: 695.541,
    y1: -43.307,
    y2: 916.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087cfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9452a9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 22.035 14.685-14.019 475.398 366.884s-51.457 36.954-54.645 30.796c-3.243-6.16-435.438-383.661-435.438-383.661z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m426.048 402.174-122.094-246.701 80.145-48.272 105.984 267.7z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m384.097 107.201-223.583 498.212-82.819-61.47 210.661-412.869z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1368.59-109-40.07 203.531-1168.404 525.31-82.42-75.898z",
    fill: "url(#d)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbLine);
export default __webpack_public_path__ + "static/media/rb-line.2cdebe52e4318b622c101a62d1eb664e.svg";
export { ForwardRef as ReactComponent };